import './styles/news';
import './images/news-all-bg.jpg';

import $ from 'jquery'

import Barba from 'barba.js';
import { isFirst } from './common'

const ACTIVE = 'is-active';

// Пепетс какой-то
function newsOn() {
  function init_news() {
      // Открываем новости при загрузке странице
      // function open_news() {
          // let $nav = $('.news-nav__item').first();
          // let $feedsection = $('.news-feed__section').first();
          // let $feeditem = $feedsection.children('.news-feed__item').first();
          // let $contentsection = $('.news-content__section').first();
          // let $contentitem = $contentsection.children('.news-content__item').first();


          // $feedsection.addClass(ACTIVE);
          // $feeditem.addClass(ACTIVE);
          // $contentsection.addClass(ACTIVE);
          // $contentitem.addClass(ACTIVE);
          // $nav.addClass(ACTIVE);
      // }

      // Открываем навигацию на маленьких разрешениях
      $('.news-sidebar__collapse').click(function () {
          let $sidebar = $('.news-sidebar');

          if (!$sidebar.hasClass(ACTIVE)) {
              $sidebar.addClass(ACTIVE);
          } else {
              $sidebar.removeClass(ACTIVE);
          }
      });

      // Открываем нужный раздел новостей
      // $('.news-nav__link').click(function(e) {
      //   e.preventDefault();
      //
      //   let $self = $(this);
      //   let tag = $self.data('tag');
      //   let $item = $self.parent();
      //   let $items = $('.news-nav__item');
      //   let $feeds = $('.news-feed__section');
      //   let $feeditems = $('.news-feed__item');
      //   let $sidebar = $('.news-sidebar');
      //
      //   $items.removeClass(ACTIVE);
      //   $feeds.removeClass(ACTIVE);
      //   $feeditems.removeClass(ACTIVE);
      //   $item.addClass(ACTIVE);
      //   $('.news-feed__section[data-tag=' + tag + ']').addClass(ACTIVE).children('.news-feed__item').first().addClass(ACTIVE);
      //
      //   if ($sidebar.hasClass(ACTIVE)) {
      //     $sidebar.removeClass(ACTIVE);
      //   }
      // });

      // Открываем новости по клику из news-feed
      // $('.news-feed__item').click(function() {
      //   let $self = $(this);
      //   let $items = $('.news-feed__item');
      //   let tag = $self.parent().data('tag');
      //   let $contents = $('.news-content__section');
      //   let index = $self.index() - 1;
      //   let $contentitems = $('.news-content__section[data-tag=' + tag + ']').children('.news-content__item');
      //   let $content = $(($contentitems)[index]);
      //
      //   console.log($content);
      //
      //   $items.removeClass(ACTIVE);
      //   $contents.removeClass(ACTIVE);
      //   $contentitems.removeClass(ACTIVE);
      //   $self.addClass(ACTIVE);
      //   $('.news-content__section[data-tag=' + tag + ']').addClass(ACTIVE);
      //   $content.addClass(ACTIVE);
      //   $('.news-content').addClass(ACTIVE);
      // });
      //
      // $('.news-content__collapse').click(function() {
      //   $('.news-content').removeClass(ACTIVE);
      // });

      // open_news();

      const tags = ['company', 'events', 'publications'];

      const $listItem = $('.news-feed__item');
      const firstNews = $listItem.first();
      const segments = cleanArray(window.location.pathname.split('/'));

      // Если индексная новостей или активен фильтр
      if((segments[2] === 'news' && !segments[3] || tags.indexOf(segments[3]) !== -1) && segments.length !== 6) {
          firstNews.addClass(ACTIVE);
          ajaxLoadNews(firstNews.attr('data-code'));
      }

      $listItem.on('click', function() {
          $listItem.removeClass(ACTIVE);
          let showNews = $(this).attr('data-code');
          history.pushState({}, "", showNews);
          $(this).addClass(ACTIVE);
          ajaxLoadNews(showNews);
      });

      $('.news-content').on('click', '.news-content__collapse', function() {
        $('.news-content').removeClass(ACTIVE);
      });


  }

  function cleanArray(array) {
      array.forEach(function(x, y) {
          if(!x) delete array[y];
      });

      return array;
  }

  $(function () {
      init_news();


  });

  function ajaxLoadNews(news) {
      let $newsContent = $('.news-content__section');

      $.ajax({
          type: 'POST',
          data: {'code': news},
          url: '/include/news_ajax.php',

          success: function (result) {
              $newsContent.empty();
              $newsContent.append(JSON.parse(result).html);
              $newsContent.parent().addClass('is-active');
          }
      });
  }
}

!isFirst || newsOn()

const News = Barba.BaseView.extend({
    namespace: 'company',

    onEnter() {
        //console.log('Новый контейнер готов и прикреплен к dom.')
    },

    onEnterCompleted() {
        //console.log('Переход закончился.')
        newsOn();
    },

    onLeave() {
        //console.log('Новый переход к новой странице только начался.')
    },

    onLeaveCompleted() {
        //console.log('Контейнер был удален из dom.')
    },
});

News.init();



// WEBPACK FOOTER //
// ./news.js